<template>
  <div class="home">

    <div class="content" ref="content">

      <div class="fullpage-container hidden-sm-down">
        <div class="fullpage-wp" v-fullpage="opts" ref="fullpage">
          <div class="page-1 page">
            <div class="bg_wrapper">
              <div class="polygon"></div>
              <div class="bg_container" 
                  v-bind:class="['active' + visual]"
              >
                <div class="bg">
                  <img src="../assets/home_bg.jpg"/>
                </div>  
                <div class="bg">
                  <img class="tagline" src="../assets/home_bg_2_tagline.jpg"/>
                  <img src="../assets/home_bg_2.jpg"/>
                </div> 
              </div>
            </div>

            <div class="slogan">
              <div class="artwork_wrapper">
                <div class="link_wrapper">
                  <router-link to="/product/cockroach" class="cockroach_1"><span></span></router-link>
                  <a class="cockroach_2" v-on:click="jumpToCockroach(1)"><span></span></a>
                  <a class="cockroach_gel" v-on:click="jumpToCockroach(2)"><span></span></a>
                  <router-link to="/product/ant" class="ant_1"><span></span></router-link>
                </div>
                <img src="../assets/home_slogan2.png"/>
              </div>
            </div>
            <div class="claim">
              <div class="claimFef">
                <!-- *資料來源：Home Care: Euromonitor from trade sources/national statistics. -->
                *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021
              </div>
              <!-- <div class="claimFef">
                URL: http://www.portal.euromonitor.com/portal/statistics/tab. Accessed on 24 March 2016
              </div> -->
            </div>

            <div class="visual_switch">
              <div class="switch" 
                  v-bind:class="{ active: visual == 0 }"
                  @click="changeImage(0)"></div>
              <div class="switch" 
                  v-bind:class="{ active: visual == 1 }"
                  @click="changeImage(1)"></div>
            </div>

              <div class="pageControl">
                <button class="" v-on:click="scrollToProduct(1)">
                  <span class="item item-half item-icon white">
                    <svg id="bottomArrow" class="icon icon-arrow icon-rotate-down" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                      <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                    </svg>
                  </span>
                </button>
              </div>        

            <div class="divider"></div>
          </div>
          <div class="page-2 page">
              <div class="pageControl">
                <button class="" v-on:click="scrollToProduct(0)">
                  <span class="item item-half item-icon white">
                    <svg id="bottomArrow" class="icon icon-arrow icon-rotate-up" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                      <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                    </svg>
                  </span>
                </button>
              </div>  
            <contact></contact>
            <henkel-footer></henkel-footer>
          </div>
        </div>
      </div>

      <div class="mobile hidden-md-up">
        <div class="bg_container"
             v-bind:class="['active' + visual]"
        >
          <div class="mobile_bg">
            <img src="../assets/home_bg_m.jpg"/> 
          </div>
          <div class="mobile_bg">
            <img src="../assets/home_bg_2_m.jpg"/> 
          </div>
        </div>

        <div class="cartoon_container">
          <div class="slogan">
            <img src="../assets/home_slogan_m.png"/>
          </div>

          <div class="cartoon_main">
            <div class="artwork_wrapper">
              <div class="link_wrapper">
                <a class="cockroach_2" v-on:click="jumpToCockroach(1)"><span></span></a>
                <router-link to="/product/ant" class="ant_1"><span></span></router-link>
                <router-link to="/product/cockroach" class="cockroach_1"><span></span></router-link>
              </div>
              <img src="../assets/home_cartoon_main_2022.png"/>
            </div>
          </div>
          <div class="cartoon">
            <div class="artwork_wrapper">
              <div class="link_wrapper">
                <a class="cockroach_gel" v-on:click="jumpToCockroach(2)"><span></span></a>
              </div>
              <img src="../assets/home_cartoon_m_2_2022.png"/>
            </div>
            <div class="cartoon__claimRef">
              <!-- *資料來源：Home Care: Euromonitor from trade sources/national statistics. -->
              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021
            </div>
            <!-- <div class="cartoon__claimRef">
              URL: http://www.portal.euromonitor.com/portal/statistics/tab. Accessed on 24 March 2016
            </div> -->
          </div>
          <div class="divider"></div>
          <div class="visual_switch">
            <div class="switch" 
                v-bind:class="{ active: visual == 0 }"
                @click="changeImage(0)"></div>
            <div class="switch" 
                v-bind:class="{ active: visual == 1 }"
                @click="changeImage(1)"></div>
          </div>
        </div>
      
        <div>
          <contact></contact>
        </div>
        <henkel-footer></henkel-footer>

      </div>
    </div>
  </div>
</template>

<script>
import bottomArrow from '../mixins/bottomArrow.js'

export default {
  mixins: [bottomArrow],
  data () {
    return {
      msg: 'This is home',
      visual: 0,
      totalSlide: 2,
      imageTimeout: null,
      curProduct: 0,
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: (obj, prev, next) => {
          this.curProduct = next
        },
        afterChange: (obj, prev, next) => {
        }
      }
    }
  },
  head: {
    meta: [
        { name: 'application-name', content: 'combat hk' }
    ]
  },
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  destroyed () {
    window.onresize = function (e) {
      e.preventDefault()
    }
    clearTimeout(this.imageTimeout)
  },
  methods: {
    jumpToCockroach (target) {
      this.$root.switchCockroach = 1
      this.$root.switchCockroachTarget = target
      this.$router.push({path: 'product/cockroach'})
    },
    resetContentSize () {
      var vh = window.innerHeight
      var vw = document.documentElement.clientWidth
      var content = this.$refs.content
      content.style.height = 'auto'
      var contentHeight = content.clientHeight

      if (contentHeight >= vh && vw >= 768) {
        content.style.height = vh + 'px'
      } else {
        content.style.height = 'auto'
      }
    },
    scrollToProduct (index) {
      this.curProduct = index
      this.$refs.fullpage.$fullpage.moveTo(index)
    },
    scrollToBottom () {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        this.$scrollTo('body', 0.4)
        return
      }

      this.$scrollTo('.footer', 0.4)
    },
    movePrevPage () {
      this.$refs.fullpage.$fullpage.movePrev()
    },
    moveNextPage () {
      this.$refs.fullpage.$fullpage.moveNext()
    },
    changeImage (index) {
      this.visual = index
      this.startImageTimeout()
    },
    slideTransition () {
      this.visual = ++this.visual % this.totalSlide
      this.startImageTimeout()
    },
    startImageTimeout () {
      if (this.imageTimeout) {
        clearTimeout(this.imageTimeout)
      }
      this.imageTimeout = window.setTimeout(() => { this.slideTransition() }, 5000)
    }
  },
  mounted () {
    let time = 500
    const originalvw = document.documentElement.clientWidth
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      time = 1000
    }

    window.setTimeout(() => {
      this.resetContentSize()
      this.startImageTimeout()
    }, time)

    window.onresize = () => {
      var vw = document.documentElement.clientWidth
      if (vw >= 768 || vw !== originalvw) {
        location.reload()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../styles/_vars.sass"
@import "../styles/_visualSwitch.sass"
@import "../styles/_pageControl.sass"
@import "../styles/_fullpage.sass"

.home

  .content
    position: relative
    padding-top: 55px
    width: 100%
    overflow: hidden

    .fullpage-container
      @include fullpage-container
      background-color: black

      .page
        overflow: hidden
        
      .page-1
        background-color: $cartoon-bg

        &a:before
          background-color: $cartoon-bg
          content: ''
          position: absolute
          width: 100%
          height: 30%
          left: 0
          bottom: 6vh
          -ms-transform: skewY(-3deg)
          -webkit-transform: skewY(-3deg)
          transform: skewY(-3deg)
          z-index: 5

          @media only screen and (max-width: 768px)
            display: none

          @media only screen and (min-width: 768px) and (max-width: 1000px)
            bottom: 10vh

          @media only screen and (min-width: 1920px)
            height: 35%
            bottom: 0

        &a:after
          background-color: $cartoon-bg
          content: ''
          position: absolute
          width: 100%
          height: 30vh
          left: 0
          bottom: 0
          z-index: 5
          
          @media only screen and (max-width: 768px)
            display: none

        .slogan
          position: absolute
          width: 100%
          bottom: 60px
          text-align: center
          color: white
          z-index: 10

          @media only screen and (min-width: 1920px)
            // top: 38%
            top: 47%

          img
            // width: 100vh
            width: 130vh
            max-width: 100vmin

            @media only screen and (min-width: 1320px)
              max-width: 1320px;

            @media only screen and (min-width: 1920px)
              max-width: 1920px;

          .artwork_wrapper

            .link_wrapper

              a.cockroach_1
                // width: 29.785%
                // left: 34.63%
                // top: 41.186%
                width: 22.785%
                left: 21.53%
                top: 41.186%

                span
                  padding-bottom: 66.666%

              a.cockroach_2
                // width: 15.091%
                // left: 12.231%
                width: 11.491%
                left: 4.531%
                top: 54.2%

                span
                  padding-bottom: 37.368%

              a.cockroach_gel
                width: 25.785%
                left: 52.83%
                top: 41.186%

                span
                  padding-bottom: 58.666%

              a.ant_1
                // width: 15.091%
                // left: 12.231%
                width: 11.491%
                left: 4.531%
                top: 72.817%

                span
                  padding-bottom: 37.368%

        .claim
          text-align: end
          bottom: 1vh
          right: 3vh
          position: absolute
          color: white
          z-index: 10
          width: 480px

          @media only screen and (max-width: 1000px)
            width: 400px

          @media only screen and (max-width: 800px)
            width: 340px

          .claimFef
            font-size: 10px

      .page-2
        z-index: 6

        .pageControl
          bottom: 195px
        .footer
          position: absolute
          bottom: 0
          width: 100%

    .bg_wrapper
      width: 200vw
      position: relative

      .polygon
        background-color: $cartoon-bg
        content: ''
        position: absolute
        width: 100%
        height: 30%
        left: 0
        bottom: -2vh
        -ms-transform: skewY(-3deg)
        -webkit-transform: skewY(-3deg)
        transform: skewY(-3deg)
        z-index: 5

        @media only screen and (max-width: 767px)
          display: none

        @media only screen and (min-aspect-ratio: 8/6)
          position:fixed
          height: 50vh
          top: 55vh



    .bg_container
      width: 200vw
      white-space: nowrap
      font-size: 0
      position: relative

      @for $i from 0 through 4
        &.active#{$i}
          margin-left: calc(#{$i} * -100vw)

      .bg
        display: inline-block
        width: 100vw
        position: relative

        .tagline
          position: absolute
          right: 0
          top: 5%
          width: 30vw

    .pageControl
      @include pageControl
      bottom: 30px
      width: 200px
      left: 50%
      transform: translate(-50%, 0)

    .visual_switch
      position: absolute
      width: 50px
      height: 20px
      bottom: 40px
      left: 50%
      transform: translate(-50%, 0)
      z-index: 10

      .switch
        width: 13px
        height: 13px
        background: white
        -moz-border-radius: 10px
        -webkit-border-radius: 10px
        border-radius: 10px
        margin-top: 3px
        cursor: pointer

        &:first-child
          float: left
        &:last-child
          float: right

        &.active
          margin-top: 0
          width: 29px
          height: 18px
          background: #db0002
          border: 3px solid white


    .divider
      position: absolute
      text-align: center
      width: 100%
      bottom: 0

    .mobile

      .visual_switch
        width: 65px
        bottom: 10px
        z-index: 0

        .switch
          width: 17px
          height: 17px

          &.active
            width: 33px
            height: 22px

      .mobile_bg
        display: inline-block
        width: 100vw

      img
        width: 100%
        max-width: none

      .cartoon_container
        position: relative
        margin-top: -10%
        padding-bottom: 30px
        font-size: 16px
        color: white
        background-color: $cartoon-bg

        &:before
          background-color: $cartoon-bg
          content: ''
          position: absolute
          width: 100%
          height: 30%
          left: 0
          top: -5%
          -ms-transform: skewY(-3deg)
          -webkit-transform: skewY(-3deg)
          transform: skewY(-3deg)

          @media only screen and (min-width: 1920px)
            background-color: $theme-orange
        
      .slogan
        position: absolute
        width: 100%
        text-align: center
        top: -15%
      
      .cartoon_main
        width: 100%
        text-align: center
        margin-top: -14%

        .artwork_wrapper
          width: 80%

          .link_wrapper

            a.cockroach_1
              // width: 58.089%
              // left: 19.722%
              // top: 28.431%
              width: 41.989%
              left: 53.722%
              top: 39.431%

              span
                padding-bottom: 66.313%

            a.cockroach_2
              width: 39.305%
              left: 3.959%
              top: 22.206%

              span
                padding-bottom: 37.674%

            a.ant_1
              width: 39.305%
              left: 3.959%
              top: 62.026%

              span
                padding-bottom: 37.674%

      .cartoon
        width: 100%
        text-align: center
        font-size: 10px

        &__claimRef
          padding-left: 10px
          padding-right: 10px
          font-size: 10px

        .artwork_wrapper
          width: 80%

          .link_wrapper

            a.cockroach_gel
              width: 44.789%
              left: 2.722%
              top: 13.331%

              span
                padding-bottom: 56.213%

      .cartoon_main,
      .cartoon
        position: relative
        display: block
        
        > img
          width: 80%

      .contact
        padding-bottom: 10%

    .artwork_wrapper
      // width: 100vh
      width: 130vh
      max-width: 100vmin
      position: relative
      margin: 0 auto

      @media only screen and (min-width: 1320px)
        max-width: 1320px

      @media only screen and (min-width: 1920px)
        max-width: 1920px

      .link_wrapper
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0

        a
          position: absolute
          cursor: pointer

          span
            position: relative
            width: 100%
            float: left
  
</style>



// WEBPACK FOOTER //
// Home.vue?46d06024